import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useSWR from 'swr';
export var useLastSelectedTerm = function useLastSelectedTerm() {
  var router = useRouter();

  var _useSWR = useSWR('LastSelectedTerm', {
    fallbackData: null
  }),
      data = _useSWR.data,
      mutate = _useSWR.mutate;

  useEffect(function () {
    if (!router.pathname.includes('account') && !router.pathname.includes('terms')) {
      mutate(null);
    }
  }, [router === null || router === void 0 ? void 0 : router.pathname, mutate]);
  return [data, mutate];
};